import React from 'react';
import { useLocation } from 'react-router-dom';
import redirectTo from '@99designs/apps/spa/common/Ssr/redirectTo';
import { LoggedInViewerProvider, useViewer } from '@99designs/viewer';

interface AuthenticatedRouteProps {
    children: React.ReactNode;
}

const AuthenticatedRoute = ({ children }: AuthenticatedRouteProps) => {
    const location = useLocation();
    const viewer = useViewer();

    if (!viewer) {
        // If the url already contains params these should persist through login.
        const fromUrl = `${location.pathname}${location.search}`;
        redirectTo('/login', [{ key: 'from', value: fromUrl }]);
        return null;
    }

    return <LoggedInViewerProvider viewer={viewer}>{children}</LoggedInViewerProvider>;
};

export default AuthenticatedRoute;
